// extracted by mini-css-extract-plugin
export var blueSapphireLogo = "footer-module--blueSapphireLogo--RzMBd";
export var center = "footer-module--center--7Sjiv";
export var flex = "footer-module--flex--QLgmZ";
export var footer__copyright = "footer-module--footer__copyright--nDi66";
export var footer__copyrightContainer = "footer-module--footer__copyrightContainer--F36xi";
export var footer__copyrightItem = "footer-module--footer__copyrightItem--+09G-";
export var footer__copyrightItem1 = "footer-module--footer__copyrightItem1--8e6G3";
export var footer__copyrightItem3 = "footer-module--footer__copyrightItem3--8hyQk";
export var footer__divider = "footer-module--footer__divider--ei3lc";
export var footer__divider2 = "footer-module--footer__divider2--Iptgz";
export var footer__header = "footer-module--footer__header--aQACH";
export var footer__imageContainer = "footer-module--footer__imageContainer--50NYd";
export var footer__item = "footer-module--footer__item--0dkOU";
export var footer__item2 = "footer-module--footer__item2--5o1RE";
export var footer__item3 = "footer-module--footer__item3--Um3ue";
export var footer__langs = "footer-module--footer__langs--hR5fk";
export var footer__main = "footer-module--footer__main--08xH4";
export var footer__message = "footer-module--footer__message--Eu9U3";
export var footer__social = "footer-module--footer__social--GDHsM";
export var footer__wrapper = "footer-module--footer__wrapper--a84JZ";
export var footer__wrapper2 = "footer-module--footer__wrapper2--eaYYI";
export var hideOnDesktop = "footer-module--hideOnDesktop--ZaAPH";
export var img = "footer-module--img--PFqx7";
export var mM = "footer-module--m-m--ecX4-";
export var mbM = "footer-module--mb-m--Juj8B";